import React from "react";
import { Box } from "@mui/material";

const PDPDetails = ({ owner, appraiser, isAppraiser = false }) => {
    return (
        <Box className="flex-container">
            <dl className="row-data">
                <dt>Name</dt>
                <dd>{owner?.[0]?.name}</dd>
            </dl>
            <dl className="row-data">
                <dt>Appraiser</dt>
                <dd>{appraiser?.[0]?.name}</dd>
            </dl>
        </Box>
    );
};

export default React.memo(PDPDetails);
